import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer, createTransform, PersistConfig } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

// combine Reducers
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import { RootReducer } from "./reducers/RootReducer";

type RootReducerState = ReturnType<typeof RootReducer>;

// Strips tokens from redux-persist; tokens are managed directly in
// localStorage via helpers/tokenStorage.ts and loaded via reducer ini state.
// autoMergeLevel2 ensures the stored user profile merges with the ini
// token fields instead of replacing the entire userReducer object.
const stripTokensTransform = createTransform(
  (inboundState: any) => {
    const { accessToken, refreshToken, tempToken, ...rest } = inboundState;
    return rest;
  },
  (outboundState: any) => {
    const { accessToken, refreshToken, tempToken, ...rest } = outboundState;
    return rest;
  },
  { whitelist: ["userReducer"] }
);

const persistConfig: PersistConfig<RootReducerState> = {
  key: "root",
  storage,
  whitelist: ["userReducer", "financialFormReducer"],
  transforms: [stripTokensTransform],
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

export const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
